// Tabs

import { enums } from '@kattana-io/common';
import Text from '../../../atoms/Text';

// Tabs
const tabs: ITab[] = [
  { name: 'DEX', isActive: true, kind: enums.ETickerKind.DEX },
  { name: 'CEX', isActive: true, kind: enums.ETickerKind.CEX },
  { name: 'NFT POOL', isActive: false, kind: enums.ETickerKind.UNAVAILABLE },
];

interface ITab {
  name: string;
  isActive: boolean;
  kind: enums.ETickerKind;
}


interface ITabsSelector {
  value: enums.ETickerKind
  onChange: (val: enums.ETickerKind) => void
  isMobile: boolean
}

interface ITabComponent {
  name: string;
  className: string;
  onClick: () => void
}

const Tab = ({name, className, onClick}: ITabComponent) => {
  const tab_names = name.split(' ');
  return <div className={className}>
    {tab_names.map((i) => <div key={i} className="tabs_container__tabs__item_name" onClick={onClick}><Text size={12}>{i}</Text></div>)}
  </div>;
};

const TabsSelector = ({ value, onChange, isMobile }: ITabsSelector) => {
  const mobile = isMobile ? '__mobile' : '';
  /**
     * Gets className for an item
     * @returns className
     */
  const getClassName = (tab: ITab) => {
    if (tab.kind !== enums.ETickerKind.UNAVAILABLE) {
      if (tab.kind === value || value === enums.ETickerKind.ALL) { return `tabs_container${mobile}__tabs__item tabs_container${mobile}__tabs__item--active`; }
      return `tabs_container${mobile}__tabs__item`;
    }
    return `tabs_container${mobile}__tabs__item tabs_container${mobile}__tabs__item--disabled`;
  };

  const onClick = (item: ITab) => {
    if(item.kind === enums.ETickerKind.UNAVAILABLE){
      return;
    }
    if (item.kind != value) {
      return onChange(item.kind);
    }
    return onChange(enums.ETickerKind.ALL);
  };

  return <div className={`tabs_container${mobile}`}>
    <div className={`tabs_container${mobile}__tabs`}>
      {tabs.map((item) =>
        <Tab key={item.name} name={item.name} className={getClassName(item)} onClick={() => onClick(item)}/>)}
    </div>
  </div>;

};

export default TabsSelector;